export default "__VITE_ASSET__Bek41k7A__"